var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebzIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2132 0.0476189V5.46706C13.2132 7.02365 12.3687 7.65728 11.2014 7.65728C10.0563 7.65728 9.18979 7.00466 9.18979 5.46706V0.0476189H6.79556V5.46706C6.79556 7.00466 5.95097 7.65728 4.80595 7.65728C3.674 7.65728 2.84498 7.0617 2.79646 5.60441C2.46032 5.84096 2.04702 5.98036 1.60042 5.98036C1.15158 5.98036 0.738273 5.84096 0.402225 5.60236C0.455222 8.4853 2.24593 9.79054 4.56497 9.79054C6.07262 9.79054 7.27967 9.19496 7.98274 8.11987H8.02473C8.74767 9.19488 9.95463 9.79054 11.4425 9.79054C13.7969 9.79054 15.6075 8.44519 15.6075 5.46723V0.0476189H13.2132ZM2.79413 2.51023V0.0476189H0.399902V2.5145C0.73595 2.27581 1.15149 2.13435 1.60033 2.13435C2.04693 2.13427 2.46024 2.27367 2.79413 2.51023Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73003 4.05621C2.73003 4.65179 2.22381 5.1355 1.60041 5.1355C0.976926 5.1355 0.470703 4.65187 0.470703 4.05621C0.470703 3.46055 0.976926 2.97906 1.60041 2.97906C2.22373 2.97914 2.73003 3.46063 2.73003 4.05621Z",
    fill: "#FC9F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebzIcon);
export default __webpack_public_path__ + "static/media/webz-icon.f34318547ba17dcd0329dd10182921fb.svg";
export { ForwardRef as ReactComponent };